// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.boilerroom {
    display: flex;
    flex-direction: column;
    align-items: center;

    margin-top: 5vh;
    width: 70vw;
}

.boilerroom h2 {
    font-size: 1.8em;
    margin-bottom: 5vh;
}

.boilerroom table, .boilerroom th, .boilerroom td {
    border: 1px solid black;
    text-align: center;
}

.boilerroom th, .boilerroom td {
    padding: .5em;
    font-size: 1.3em;
}

.boilerroom td {
    cursor: pointer;
}

.other_month {
    background-color: #70704B;
}

.is_recorded {
    background-color: red;
}

.boilerroom > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    
    font-size: 1.3em;
    margin-top: 5vh;
}

.boilerroom > div > * {
    margin-top: 2vh;
}

.boilerroom_content {
    display: flex;
    justify-content: space-around;
    width: 20vw;
}
.boilerroom_content label {
    margin-right: 2vw;
}

.boilerroom_content input {
    font-size: 1em;
    text-align: center;
    width: 45%;
}

.boilerroom_content button {
    margin: 2vw;
}

@media only screen and (width < 920px) {
    .boilerroom_content input {
        font-size: 1em;
        text-align: center;
        width: fit-content;
    }

    .boilerroom_content {
        display: flex;
        justify-content: space-around;
        width: 80vw;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Boilerroom.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;IAEnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;;IAE7B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,WAAW;AACf;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,cAAc;QACd,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,6BAA6B;QAC7B,WAAW;IACf;AACJ","sourcesContent":[".boilerroom {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    margin-top: 5vh;\n    width: 70vw;\n}\n\n.boilerroom h2 {\n    font-size: 1.8em;\n    margin-bottom: 5vh;\n}\n\n.boilerroom table, .boilerroom th, .boilerroom td {\n    border: 1px solid black;\n    text-align: center;\n}\n\n.boilerroom th, .boilerroom td {\n    padding: .5em;\n    font-size: 1.3em;\n}\n\n.boilerroom td {\n    cursor: pointer;\n}\n\n.other_month {\n    background-color: #70704B;\n}\n\n.is_recorded {\n    background-color: red;\n}\n\n.boilerroom > div {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-around;\n    \n    font-size: 1.3em;\n    margin-top: 5vh;\n}\n\n.boilerroom > div > * {\n    margin-top: 2vh;\n}\n\n.boilerroom_content {\n    display: flex;\n    justify-content: space-around;\n    width: 20vw;\n}\n.boilerroom_content label {\n    margin-right: 2vw;\n}\n\n.boilerroom_content input {\n    font-size: 1em;\n    text-align: center;\n    width: 45%;\n}\n\n.boilerroom_content button {\n    margin: 2vw;\n}\n\n@media only screen and (width < 920px) {\n    .boilerroom_content input {\n        font-size: 1em;\n        text-align: center;\n        width: fit-content;\n    }\n\n    .boilerroom_content {\n        display: flex;\n        justify-content: space-around;\n        width: 80vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
